/**
 * Bot-Erkennung für den Web-Tracker (2026-09-25). Liste IDENTISCH zum Backend
 * `dartcloud-backend/src/core/services/analytics/bot-detection.js` – Änderungen
 * immer an beiden Stellen. Crawler (Ahrefs, Meta-Crawler, bingbot …) führen unser
 * JavaScript aus und würden sonst Analytics-Events wie Menschen feuern.
 */
export const BOT_TOKENS = [
  'crawler', 'crawl', 'spider', 'externalagent', 'externalhit', 'facebookexternalhit', 'slurp', 'bingpreview',
  'headless', 'python-requests', 'curl/', 'wget/', 'httpclient', 'okhttp', 'go-http', 'scrapy', 'semrush',
  'ahrefs', 'mj12', 'dotbot', 'petalbot', 'yandex', 'baidu', 'duckduck', 'applebot', 'gptbot', 'claudebot',
  'anthropic', 'openai', 'perplexity', 'bytespider', 'amazonbot', 'ccbot', 'lighthouse', 'pagespeed',
  'gtmetrix', 'pingdom', 'uptimerobot',
];

const escape = (s: string): string => s.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&');

/** Regex-Quelltext für MongoDB (PCRE, Lookbehind erlaubt) – Backend nutzt denselben. */
export const BOT_REGEX_SOURCE = `(?<!cu)bot(?:[^a-z]|$)|${BOT_TOKENS.map(escape).join('|')}`;

// Browser-seitig ohne Lookbehind (ältere Safari-Versionen werfen sonst beim Laden):
// „…bot“ als Endung (bingbot/, Googlebot/, AhrefsBot/), Ausnahme Cubot-Handys.
const TOKENS_REGEX = new RegExp(BOT_TOKENS.map(escape).join('|'), 'i');
const GENERIC_BOT_REGEX = /bot(?:[^a-z]|$)/i;
const KNOWN_DEVICE_REGEX = /cubot/i;

/** true, wenn der User-Agent nach Crawler/Bot/Monitoring-Tool aussieht; leer → false. */
export const isBotUserAgent = (userAgent: string | null | undefined): boolean => {
  if (typeof userAgent !== 'string' || userAgent.length === 0) return false;
  if (TOKENS_REGEX.test(userAgent)) return true;
  return GENERIC_BOT_REGEX.test(userAgent) && !KNOWN_DEVICE_REGEX.test(userAgent);
};

/** Aktueller Browser ein Bot? Fail-soft: ohne navigator → false. */
export const isBotBrowser = (): boolean => {
  try {
    return isBotUserAgent(typeof navigator !== 'undefined' ? navigator.userAgent : '');
  } catch {
    return false;
  }
};
